<template>
  <div>
    <EditForm :student="student"/>
  </div>
</template>

<script>
import EditForm from '@/pages/admin/student/EditForm'
import StudentService from '@/services/StudentService'

export default {
  props: {
    id: String
  },
  components: {EditForm},
  data: () => ({
    student: StudentService.getDefaultItem()
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/student/Edit.vue